module.exports = __webpack_public_path__ + "static/media/cert_161.110f6e8c.jpg";